import gql from 'graphql-tag';
export const factFragment = gql `
  fragment Fact on Fact {
    matchId
    id
    name
    teamId
    playerId
    minute
    date
    period
    data
  }
`;
//# sourceMappingURL=Fact.js.map